import React from 'react';
import GuitarNeckVisualizer from './GuitarNeckVisualizer';
import { useLessonNeck } from '../hooks/useLessonNeck';

/**
 * Adaptateur entre le magasin de la lecon et le manche : le seul composant qui
 * se rend a chaque pas. Toutes les autres props viennent de App inchangees, et
 * GuitarNeckVisualizer reste memoise sur elles.
 */
const LessonNeck = ({ active = false, ...neckProps }) => {
  const { notes, lowestFret } = useLessonNeck();
  return (
    <GuitarNeckVisualizer
      {...neckProps}
      lessonNotes={active ? notes : null}
      scrollToFret={active ? lowestFret : null}
    />
  );
};

export default LessonNeck;
